export const przypomnienieTrescSms = (kwota, konto, nazwa ) => (
    [
        `Szanowni Państwo, przypominamy o zaległości w wysokości ${kwota} na rzecz ${nazwa}. Prosimy o pilne uregulowanie płatności na numer konta bankowego ${konto}.`,
        `Więcej szczegółów na stronie bit.ly/3Yv0v9x`,
        `Biuro Obsługi Nieruchomości Mojsiewicz & Stanek.`
    ].join('\n')
);

export const wezwanieTrescSms = (kwota, konto, nazwa ) => (
    [
        `Szanowni Państwo, wzywamy do uregulowania zaległości w kwocie ${kwota} na rzecz ${nazwa}. Wpłaty należy dokonać w terminie 5 dni od otrzymania wiadomości na konto ${konto}. Brak płatności może skutkować dodatkowymi kosztami windykacyjnymi.`,
        `Więcej szczegółów na stronie bit.ly/3Yv0v9x`,
        `Biuro Obsługi Nieruchomości Mojsiewicz & Stanek.`
    ].join('\n')
);

export const przypomnienieTrescMail = (kwota, konto, nazwa) => (`Szanowni Państwo,<br/><br/>przypominamy o zaległości w wysokości ${kwota} na rzecz ${nazwa}. Prosimy o pilne uregulowanie płatności na numer konta bankowego ${konto}.<br/>Więcej szczegółów na stronie <a href="bit.ly/3Yv0v9x">bit.ly/3Yv0v9x</a>.<br/><br/>Biuro Obsługi Nieruchomości Mojsiewicz & Stanek.`);

export const wezwanieTrescMail = (kwota, konto, nazwa) => (`Szanowni Państwo,<br/><br/>wzywamy do uregulowania zaległości w kwocie ${kwota} na rzecz ${nazwa}.<br/>Wpłaty należy dokonać w terminie 5 dni od otrzymania wiadomości na konto ${konto}. Brak płatności może skutkować dodatkowymi kosztami windykacyjnymi.<br/>Więcej szczegółów na stronie <a href="bit.ly/3Yv0v9x">bit.ly/3Yv0v9x</a>.<br/><br/>Biuro Obsługi Nieruchomości Mojsiewicz & Stanek.`);
    